"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createExchangeInstruction = void 0;
const anchor_1 = require("@project-serum/anchor");
const web3_js_1 = require("@solana/web3.js");
const utils_1 = require("../utils");
const pda_getters_1 = require("../pda_getters");
const pda_getters_2 = require("../pda_getters");
const util_1 = require("../../util");
const models_1 = require("../models");
/**
 * Creates an instruction which exchanges tokens between order initializer and order taker to satisfy the exchange detailed in orderAccount
 *
 * @param connection
 * @param orderAccount - an initialized orderAccount
 * @param purchaseQty - Number of items to be purchased
 * @param orderTaker - Public key of the order taker
 * @param orderTakerDepositTokenAccount - Public key of token account for token being sent by taker
 * @param programId - Deployed program ID for GM program
 * @param expectedPrice - Expected price of the order in base token units
 * @param orderType - The OrderSide for this order - Buy or Sell
 * @param assetMint - Mint of the underlying asset
 * @param currencyMint - Mint of the currency being exchanged
 * @param orderInitializer - Public key of the order initializer
 * @param saVault - Token account for SA currency mint royalties
 * @param stakingProgramId - Deployed program ID for the Staking program
 * @param registeredStake - ATLAS staking `RegisteredStake` account
 * @param stakingAccount - Seller's ATLAS staking account
 */
function createExchangeInstruction({ connection, orderAccount, purchaseQty, orderTaker, orderTakerDepositTokenAccount, programId, expectedPrice, orderType, assetMint, currencyMint, orderInitializer, saVault, stakingProgramId, registeredStake, stakingAccount, }) {
    return __awaiter(this, void 0, void 0, function* () {
        const program = (0, utils_1.getMarketplaceProgram)({ connection, programId });
        const ixSet = {
            signers: [],
            instructions: [],
        };
        // Get order account and info
        const initializerDepositMint = orderType === models_1.OrderSide.Sell
            ? new web3_js_1.PublicKey(assetMint)
            : new web3_js_1.PublicKey(currencyMint);
        const initializerReceiveMint = orderType === models_1.OrderSide.Sell
            ? new web3_js_1.PublicKey(currencyMint)
            : new web3_js_1.PublicKey(assetMint);
        // Get user's token accounts
        let initializerDepositTokenAccount = null;
        let initializerReceiveTokenAccount = null;
        let orderTakerReceiveTokenAccount = null;
        // Get initializer deposit mint token account
        let response = yield (0, util_1.getTokenAccount)(connection, orderInitializer, initializerDepositMint, orderTaker);
        if ('createInstruction' in response) {
            ixSet.instructions.push(response.createInstruction);
            if (response.tokenAccount instanceof anchor_1.web3.Keypair) {
                initializerDepositTokenAccount = response.tokenAccount.publicKey;
                ixSet.signers.push(response.tokenAccount);
            }
            else {
                initializerDepositTokenAccount = response.tokenAccount;
            }
        }
        else {
            initializerDepositTokenAccount = response.tokenAccount;
        }
        // Get initializer receive mint token account
        response = yield (0, util_1.getTokenAccount)(connection, orderInitializer, initializerReceiveMint, orderTaker);
        if ('createInstruction' in response) {
            ixSet.instructions.push(response.createInstruction);
            if (response.tokenAccount instanceof anchor_1.web3.Keypair) {
                initializerReceiveTokenAccount = response.tokenAccount.publicKey;
                ixSet.signers.push(response.tokenAccount);
            }
            else {
                initializerReceiveTokenAccount = response.tokenAccount;
            }
        }
        else {
            initializerReceiveTokenAccount = response.tokenAccount;
        }
        const [orderVaultAccount] = yield (0, pda_getters_1.getOrderVault)(orderInitializer, initializerDepositMint, programId);
        const [openOrdersCounter] = yield (0, pda_getters_2.getOpenOrdersCounter)(orderInitializer, initializerDepositMint, programId);
        // Get order taker receive token account
        response = yield (0, util_1.getTokenAccount)(connection, orderTaker, initializerDepositMint);
        if ('createInstruction' in response) {
            ixSet.instructions.push(response.createInstruction);
            if (response.tokenAccount instanceof anchor_1.web3.Keypair) {
                orderTakerReceiveTokenAccount = response.tokenAccount.publicKey;
                ixSet.signers.push(response.tokenAccount);
            }
            else {
                orderTakerReceiveTokenAccount = response.tokenAccount;
            }
        }
        else {
            orderTakerReceiveTokenAccount = response.tokenAccount;
        }
        const seller = orderType === models_1.OrderSide.Buy ? orderTaker : orderInitializer;
        const exchangeIx = yield program.methods
            .processExchange(new anchor_1.BN(purchaseQty), expectedPrice, seller)
            .accounts({
            orderTaker,
            orderTakerDepositTokenAccount,
            orderTakerReceiveTokenAccount,
            currencyMint,
            assetMint,
            orderInitializer,
            initializerDepositTokenAccount,
            initializerReceiveTokenAccount,
            orderVaultAccount,
            orderAccount,
            openOrdersCounter,
            saVault,
            atlasStaking: stakingProgramId,
            registeredStake,
            stakingAccount,
        })
            .instruction();
        ixSet.instructions.push(exchangeIx);
        return ixSet;
    });
}
exports.createExchangeInstruction = createExchangeInstruction;
//# sourceMappingURL=exchangeOrder.js.map